<adapt-activity-feed [promiseToGetInitialActivity]="promiseToGetInitialActivity"
                     [promiseToGetOlderActivity]="promiseToGetOlderActivity"
                     [promiseToGetNewerActivity]="promiseToGetNewerActivity"
                     emptyFeedText="There is no personal activity to display"
                     feedTitle=""></adapt-activity-feed>
